import { C11ReverseRowStoryWithVisualProps } from './C11ReverseRowStoryWithVisual';
import { C11ReverseRowStoriesProps } from './C11ReverseRowStories';
import { REVERSE_ROW_STORIES_CONTAINER } from 'src/shared/static';
import { ReverseRowProps, ReverseRowsProps } from '@ahc-digital/component-library';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getCheckbox, getDroplink } from 'src/shared/param-utils';
import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';

export function CreateReverseRowStoryWithVisualModel(
  props?: C11ReverseRowStoryWithVisualProps
): ReverseRowProps {
  type t = ReverseRowProps;
  const { params, fields } = props || {};
  const { renderText, renderRichText, renderLink, renderImage } = useConditionalRendering();

  return {
    headline: renderText(fields?.Title, { required: true }),
    firstCta: renderLink(fields?.FirstCTA),
    secondCta: renderLink(fields?.SecondCTA),
    ctaStyle: getDroplink<t['ctaStyle']>(params?.CTAStyle, 'button'),
    mediaSide: getDroplink<t['mediaSide']>(params?.ImageSide, 'left'),
    headlineTag: getDroplink<t['headlineTag']>(params?.TitleType, 'p'),
    supportingCopy: renderRichText(fields?.SupportingCopy),
    image: renderImage(fields?.Image),
    contentAlignment: getDroplink<t['contentAlignment']>(params?.ContentVerticalAlignment, 'top'),
    videoId: props?.fields?.VideoID?.value || '',
    shouldLazyLoad: getCheckbox(params?.ShouldLazyLoad),
  };
}

export function CreateReverseRowStoriesModel(props?: C11ReverseRowStoriesProps) {
  type t = ReverseRowsProps;
  const { rendering, params, fields } = props || {};
  const { renderRichText, renderLink, renderText } = useConditionalRendering();

  const removePaddingBetweenRows = props?.params?.RemovePaddingBetweenRows;
  return {
    headline: renderText(fields?.Title),
    headlineTag: getDroplink<t['headlineTag']>(params?.TitleType, 'h2'),
    topSupportingCopy: renderRichText(fields?.TopSupportingCopy),
    bottomSupportingCopy: renderRichText(fields?.BottomSupportingCopy),
    bottomCta: renderLink(fields?.BottomCTA),
    rows: rendering && <Placeholder name={REVERSE_ROW_STORIES_CONTAINER} rendering={rendering} />,
    shouldRemovePaddingBetweenRows: !!removePaddingBetweenRows,
    shouldLazyLoad: getCheckbox(params?.ShouldLazyLoad),
  };
}
